/**
 * @prettier
 */

import React from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';

import { LeadCardType } from '@zola/zola-ui/src/paper/cards/constants/cardTypes';

import { openModal } from '~/cards/actions/modalActions';
import type { AppDispatch } from '~/reducers/useAppDispatch';
import { ModalOptions } from '~/components/common/types';
import styles from './styles.module.less';
import {
  ActiveFilters,
  IndividualVisibilityCheck,
  FilterOptionList,
  FilterValue,
  FilterKey,
} from '../FilterTypes';

const FilterMenu = ({
  activeFilters,
  updateFilter,
  content: Component,
  optionList,
  filterStateKey,
  showModal,
  individualVisibilityCheck,
  className,
  cardType,
}: FilterMenuProps) => {
  return (
    <div className={cx(styles.filterMenuContent, className)}>
      <Component
        optionList={optionList}
        activeFilters={activeFilters}
        updateFilter={updateFilter}
        activeValue={filterStateKey ? activeFilters[filterStateKey] : null}
        activeSeoValue={filterStateKey === 'multiColor' ? activeFilters.seo_colors : null}
        showModal={showModal}
        individualVisibilityCheck={individualVisibilityCheck}
        cardType={cardType}
      />
    </div>
  );
};

export type FilterMenuProps = {
  activeFilters: ActiveFilters;
  updateFilter: (key: FilterKey, value: FilterValue) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  content: React.FC<any>;
  optionList?: FilterOptionList;
  filterStateKey?: FilterKey;
  showModal: (
    modalType: string,
    modalProps: Record<string, unknown>,
    modalOptions: ModalOptions
  ) => void;
  individualVisibilityCheck?: IndividualVisibilityCheck;
  className?: string;
  cardType?: LeadCardType;
};

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  showModal: (modalType: string, modalProps: Record<string, unknown>, modalOptions: ModalOptions) =>
    dispatch(openModal(modalType, modalProps, modalOptions)),
});

export default connect(null, mapDispatchToProps)(FilterMenu);
